import { gql } from "graphql-tag";

export const PROCESS_REMOVALS_VIEW = gql`
  query ProcessRemovalsView($list: ID!, $limit: Int!, $offset: Int!, $search: String) {
    templates {
      id
      name
      type
      isOrgTemplate
      body
    }

    interestList(id: $list) {
      id
      name
      scheduledUpdate {
        begins
        ends
        removals(limit: $limit, offset: $offset, search: $search) {
          totalCount
          results {
            name
            phone
            respondedAt
            status
            interestId
          }
        }
      }
    }
  }
`;

export const PROCESS_REMOVALS_SUBMIT = gql`
  mutation ProcessRemovals(
    $interestList: ID!
    $templateGroupId: ID!
    $emailEnabled: Boolean!
    $letterEnabled: Boolean!
    $smsEnabled: Boolean!
  ) {
    processWaitlistUpdate(
      interestList: $interestList
      templateGroupId: $templateGroupId
      emailEnabled: $emailEnabled
      letterEnabled: $letterEnabled
      smsEnabled: $smsEnabled
    )
  }
`;

export const REMOVALS_TRACKING = gql`
  query RemovalsTracking(
    $interestListId: ID!
  ) {
    removalsTracking(
      interestListId: $interestListId
    ) {
      percentComplete
    }
    interestList(id: $interestListId) {
      id
      scheduledUpdate { 
        removals(limit: 0, offset: 0) {
          totalCount
        } 
      }
    }
  }
`;

export const MANUALLY_CONTACTED = gql`
  mutation ManuallyContacted($interest: ID!) {
    manuallyContacted(interestId: $interest)
  }
`;
